import { theme } from "@product/scmp-sdk";
import { type FunctionComponent } from "react";

import { AdSlot } from "~/components/advertisement/ad-slots/ad-slot";
import { BaseLinkContextProvider } from "~/components/common/base-link/context";
import type { Props as ContentSchemaRenderProps } from "~/components/schema-render/content";

import { AdContainer, Container, LogoLink, Paris, StyledOlympicLogo } from "./styles";

type Props = {
  className?: string;
  pageType: "section" | "article";
} & Pick<ContentSchemaRenderProps, "advertising">;
export const OlympicWidgetsHeader: FunctionComponent<Props> = ({
  advertising,
  className,
  pageType,
}) => (
  <Container className={className}>
    <BaseLinkContextProvider
      customQueryParameters={{
        module: "olympics2024",
        pgtype: pageType === "section" ? "sub-section" : pageType,
      }}
    >
      <LogoLink pathname="/paris-olympics">
        <StyledOlympicLogo />
        <Paris>Paris 2024</Paris>
      </LogoLink>
    </BaseLinkContextProvider>
    <AdContainer>
      <AdSlot
        adUnit="d_banner3"
        breakpoint={theme.breakpoints.up("tablet")}
        sizes={[[100, 61], "fluid"]}
        {...advertising}
      />
      <AdSlot
        adUnit="m_banner2"
        breakpoint={theme.breakpoints.only("mobile")}
        sizes={[[100, 61], "fluid"]}
        {...advertising}
      />
    </AdContainer>
  </Container>
);

OlympicWidgetsHeader.displayName = "OlympicWidgetsHeader";
